import React from "react";
import { ShieldCheckIcon, LockIcon, CreditCardIcon, StarIcon } from "lucide-react";
import { brand, hero } from "../data/salesCopy";
import { optimizedImage, optimizedSrcSet, fallbackToOriginal } from "../utils/image";
import { CtaButton } from "./CtaButton";
const trustIcons = [ShieldCheckIcon, LockIcon, CreditCardIcon];
export function Hero() {
  return <header className="bg-chalk text-white" data-id="element-119" data-mp="4jvup7vn12uo">
      <div className="mx-auto max-w-3xl px-5 pb-8 pt-7 text-center md:pb-14 md:pt-12" data-id="element-120" data-mp="128frdnreylxt">
        <p className="text-xs font-semibold text-pencil md:text-sm" data-id="element-121" data-mp="x9un9d91ji43">{brand.product}</p>
        <h1 className="mt-2 font-display text-[2rem] font-extrabold leading-[1.05] sm:text-5xl lg:text-6xl" data-id="element-122" data-mp="sb1c3rh88373">{hero.title}</h1>

        <div className="relative mx-auto mt-5 w-[70%] max-w-md" data-id="element-123" data-mp="nb6llp1d5fmk">
          <img src={optimizedImage(brand.heroImage, 480)} srcSet={optimizedSrcSet(brand.heroImage, 480)} onError={fallbackToOriginal(brand.heroImage)} width={480} height={480} alt="Megapack Docente 2027: caja con tomos impresos, calendario 2027 y fichas sobre un escritorio de aula" loading="eager" decoding="async"
        // @ts-expect-error fetchpriority is a valid HTML attribute not yet in React 18 types
        fetchpriority="high" className="aspect-square w-full rounded-2xl bg-chalk-dark object-cover ring-1 ring-white/10 md:rounded-3xl" data-id="element-124" data-mp="3d1a83izra9cr" />
          <dl className="absolute inset-x-1.5 bottom-1.5 grid grid-cols-3 divide-x divide-white/15 rounded-xl bg-chalk-dark/90 py-1.5 backdrop-blur md:inset-x-3 md:bottom-3 md:py-2.5" data-id="element-125" data-mp="30fy9dwffp1xr">
            {hero.stats.map((s, i) => <div key={s.label} className="px-1" data-id="element-126" data-mp="2viokchvyisag" data-mpi={i}>
                <dt className="sr-only" data-id="element-127" data-mp="2vjg9payyntsa">{s.label}</dt>
                <dd className="flex items-center justify-center gap-1 text-sm font-extrabold md:text-xl" data-id="element-128" data-mp="2hinbaf5jgejw">
                  {s.value}
                  {i === 1 && <StarIcon className="h-3.5 w-3.5 fill-pencil text-pencil" aria-hidden="true" data-id="element-129" data-mp="2ljz22o05f5to" />}
                </dd>
                <dd className="text-[9px] text-white/70 md:text-xs" data-id="element-130" data-mp="s3uqhvk0f6a3">{s.label}</dd>
              </div>)}
          </dl>
        </div>

        <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-white/90 md:text-lg" data-id="element-131" data-mp="ibgnz0l3xvmv">{hero.subtitle}</p>

        <div className="mt-4 flex items-center justify-center gap-3" data-id="element-132" data-mp="dege0el508qh">
          <span className="font-display text-4xl font-extrabold text-pencil md:text-5xl" data-id="element-133" data-mp="1b1ffd2mry4up">{hero.bigNumber}</span>
          <span className="text-left text-sm font-semibold leading-tight md:text-base" data-id="element-134" data-mp="161j7utevbvae">
            {hero.bigNumberLabel}
            <span className="block text-xs font-normal text-white/70 md:text-sm" data-id="element-135" data-mp="111507ch6incw">{hero.kicker}</span>
          </span>
        </div>

        <ul className="no-scrollbar -mx-5 mt-3 flex gap-2 overflow-x-auto px-5 sm:mx-0 sm:justify-center sm:px-0" data-id="element-136" data-mp="x3h1dycd8afq">
          {hero.tags.map(t => <li key={t} className="shrink-0 rounded-full bg-white/10 px-3 py-1 text-xs font-medium md:text-sm" data-id="element-137" data-mp="3hqalsx0fjpoq">{t}</li>)}
        </ul>

        <div className="mx-auto mt-6 max-w-xl" data-id="element-138" data-mp="1x7htx8b35sy8">
          <CtaButton href="#ofertas" full data-id="element-139" data-mp="21by0lbsix4ei">{hero.cta}</CtaButton>
          <ul className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-white/80 md:text-sm" data-id="element-140" data-mp="269zfdkix2hk6">
            {hero.trust.map((t, i) => {
            const Icon = trustIcons[i];
            return <li key={t} className="flex items-center gap-1.5" data-id="element-141" data-mp="2g0lrv5vc6ryn" data-mpi={i}>
                  <Icon className="h-3.5 w-3.5 text-pencil" aria-hidden="true" data-id="element-142" data-mp="2g25bn6g7bl56" />
                  {t}
                </li>;
          })}
          </ul>
        </div>
      </div>
    </header>;
}